import tool from "./tools";

export default {
  Rezervasyon(){
    return {
        pNR_No:0,
        kayitTarihi:tool.Now_yyyy_MM_dd(),
        cariKod:{id:"",kod:"",isim:"",isimAra:""},
        rezVeren:"",
        masrafMerkezi:{id:"",kod:"",isim:"",isimAra:""},
        anaTip:0,
        ulke:null,
        karsiRezKod:"",
        turKod:"",
        acenteDepartman:{id:"",kod:"",isim:"",isimAra:""},
        hizmetNo:"",
        referansKod:"",
        adresler: [],
        kalemler:[],
        toplamTL: {
          satis: 0,
          alis: 0,
          komisyon: 0,
          iskonto: 0
        },
        

      }
  },
  Adres(){
    return {
        id:0,
        kisiTip:0,
        kisiSira:-1,
        yas:0,
        profilId:0,
        tcKimlikNo:"",
        uyeNo:"",
        adSoyad:"",
        adres:"",
        dogumTarihi:null,
        cinsiyet:"",
        telefon1:"",
        gsm:"",
        eMail:"",
        
    }
  },

  Para(){
    return {
      paraBirimi:"TL",
      kur:1,
      kurTarihi:null          
    }
  },

  Kalem(){
    return {
     dialogShow:false,
     islemRef:0, 
     saticiKod:"", 
     donem1:"2018-06-01", 
     donem2:"2018-06-02", 
     satis:{KDVOran:null}, 
     alis:null, 
     komisyon: {KDVOran:null, tutar:null}, 
     acenteKomisyon: null, 
     iskonto: {oran:null,tutar:null}, 
     odeyenTaraf: -1, 
     aciklama: "", 
     tedarikciAciklama: null, 
     turOperatoru: {id:"",kod:"",isim:"",isimAra:""}, 
     departman: {id:"",kod:"",isim:"",isimAra:""}, 
     kdvID:{id:"",kod:"",isim:"",isimAra:""},
     kdvMuafiyetID:{id:"",kod:"",isim:"",isimAra:""},

     entegrasyonKodu:null,
     maliyetCariKod: null,
      
     saticiTip: 1, 
     kisiSira:[],

     Yet_Satis:0,
     Co1_Satis:0,
     Co2_Satis:0,
     Co3_Satis:0,
     Co4_Satis:0,
     EkY_Satis:0,
     satici:{id:"",kod:"",isim:"",isimAra:""},
     kalemOtel: {odaTipi:null,pansiyon:null}, 
     kalemDiger: {isAciklama:null},
     alisPara:this.Para(),
     satisPara:this.Para(),
     komisyonPara:this.Para(),
     komisyonYuzdeTip:0,
     
     
     

    } 
  },

  KisiTipToStr(tip){
    return this.KisiTip[tip].Aciklama
  },

  SaticiTipToStr(tip){
    return this.SaticiTip[tip-1].Aciklama
  },


  KisiTip: [{Kod:0, Aciklama:"Yetişkin"},{Kod:1, Aciklama:"Çocuk 1"},{Kod:2, Aciklama:"Çocuk 2"},{Kod:3, Aciklama:"Çocuk 3"}, {Kod:4, Aciklama:"Çocuk 4"},{Kod:5, Aciklama:"Ek Yatak"},],

  SaticiTip : [
    {Aciklama:"Otel",Kod:1},
    {Aciklama:"Arac",Kod:2},
    {Aciklama:"Restaurant",Kod:3},
    {Aciklama:"Acente",Kod:4},
    {Aciklama:"RentACar",Kod:5},
    {Aciklama:"Rehber",Kod:6},
    {Aciklama:"Muze",Kod:7},
    {Aciklama:"Charter",Kod:8},
    {Aciklama:"Gemi",Kod:9},
    {Aciklama:"Diger",Kod:10},
    {Aciklama:"Vize",Kod:11},
    {Aciklama:"TurOperatoru",Kod:12},
    {Aciklama:"Konsolosluk",Kod:13},
    {Aciklama:"Sigorta",Kod:14},
    {Aciklama:"Feribot",Kod:15},
    {Aciklama:"Golf",Kod:16}
  ],

  saticiTipleriStr: [
    {id:'Otel', text:'Otel'},
    {id:'Arac', text:'Araç'},
    {id:'Restaurant', text:'Restaurant'},
    {id:'Acente', text:'Acente'},
    {id:'RentACar', text:'Ren A Car'},
    {id:'Rehber', text:'Rehber'},
    {id:'Muze', text:'Müze'},
    {id:'Charter', text:'Charter'},
    {id:'Gemi', text:'Gemi'},
    {id:'Diger', text:'Diğer'},
    {id:'TurOperatoru', text:'Tur Operatoru'},
    {id:'Konsolosluk', text:'Konsolosluk'},
    {id:'Sigorta', text:'Sigorta'},
    {id:'Feribot', text:'Feribot'},
    {id:'Golf', text:'Golf'},
    ],

  OdemeTipi : [
    {kod:-1,aciklama:""},
    {kod:0,aciklama:"Müşteri tarafından"},
    {kod:1,aciklama:"Ekstralar hariç acentemiz tarafından"},
    {kod:2,aciklama:"Acentemiz tarafından Full-Credit"},
    {kod:3,aciklama:"Tur Operatörü Tarafından"},
  ],

  Pansiyon : [
    {kod:"OB",aciklama:"Only Bed"},
    {kod:"BB",aciklama:"Bed & Breakfast"},
    {kod:"HB",aciklama:"Half Board"},
    {kod:"FB",aciklama:"Full Board"},
    {kod:"AI",aciklama:"All Inclusive"},
    {kod:"UAI",aciklama:"Ultra All Inclusive"},
    {kod:"FF",aciklama:"FF"},
    {kod:"FC",aciklama:"FC"},
  ]
  

}


